import {debounce} from "../_functions";

document.addEventListener('DOMContentLoaded', (dom) => {
    const container = dom.target;
    const shopsList = container.querySelectorAll('.shops__shop');
    const searchInput = container.querySelector('.js-shops-search-input');

    if (shopsList.length && searchInput) {

        const getTitle = (el) => {
            const title = el.querySelector('.shop__title');
            return title ? title.innerText.toLowerCase() : '';
        };

        const getLocation = (el) => {
            const location = el.querySelector('.shop__location');
            return location ? location.innerText.toLowerCase() : '';
        };

        const filterShops = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            let shopsArray = Array.from(shopsList);

            shopsArray.forEach(post => {
                const titleText = getTitle(post);
                const locationText = getLocation(post);
                const matchSearch = searchTerm === '' || titleText.includes(searchTerm) || locationText.includes(searchTerm);

                post.classList.toggle('hidden', !(matchSearch));
            });

            const shopsWrapper = shopsList[0].parentNode;

            const fragment = document.createDocumentFragment();
            shopsArray.forEach(el => fragment.appendChild(el));
            shopsWrapper.appendChild(fragment);
        };

        const handleInput = debounce(filterShops, 300);

        searchInput.addEventListener('input', handleInput);

        filterShops();
    }
});
